import { Theme, makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(({ custom }: Theme) => ({
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  plate: {
    position: 'relative',
    display: 'inline-flex',
    alignItems: 'center',
    minHeight: 40,
    paddingLeft: 39,
    paddingRight: 10,
    background: custom.grey[8],
    borderRadius: 6,
  },
  euroband: {
    position: 'absolute',
    left: 0,
    top: 0,
    height: '100%',
    width: 28,
    background: '#2358D0 url("./images/misc/euroband.svg") no-repeat center',
    backgroundSize: 'contain',
    borderTopLeftRadius: 6,
    borderBottomLeftRadius: 6,
  },
  value: {
    fontSize: 14,
    lineHeight: 1,
    color: custom.grey[3],
    fontWeight: 400,
  },
  tooltip: {
    marginTop: 0,
  },
}));
